module.exports = __webpack_public_path__ + "static/img/3.4080284.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/sp/3.png
// module id = tiob
// module chunks = 0